import {
  disableSkeletonForItem,
  formatItemId,
  // updateItemImages,
  widgetToWidgetParamsMap,
} from '@msnt-shared/packages/froomle';
import { formatRelativeTime } from '@msnt-shared/packages';
/**
 *
 * @param {any} finalSettings
 * @param {HTMLElement} item
 * @param {any} recommendation
 * @param {HTMLElement} widget
 */

export const froomleSettings = {
  minImageSize: 7,
  maxImageSize: 1,
  imageSizesStep: 1,
  mediaTypeToExtension: {
    'image/webp': 'webp',
    'image/jpeg': 'jpg',
  },
  sizesLookUpTable: {
    1: '1920',
    2: '1440',
    3: '1280',
    4: '889',
    5: '213',
    6: '445',
    7: '16',
  },
};

export const updateItemToFroomleRecommendation = (
  finalSettings,
  item,
  recommendation,
  widget,
) => {
  console.log(
    'UPFATE ITEMS TO FROOMLE RECS:',
    finalSettings,
    item,
    recommendation,
    widget,
  );
  //return;
  updateItemImages(item, recommendation);

  // const relativeDate = formatRelativeTime(recommendation.dt_published);

  // const thumbTopInfoBlock = item.querySelector('.ms-item__thumb-info-top');

  // if (thumbTopInfoBlock) {
  //   const prime = thumbTopInfoBlock.querySelector('.ms-item__prime');
  //   if (prime) {
  //     prime.remove();
  //   }

  //   const series = thumbTopInfoBlock.querySelector('.ms-item__thumb-series');
  //   if (series) {
  //     series.innerHTML = recommendation.series_title;
  //   }
  // }

  // const topInfoBlock = item.querySelector('.ms-item__info-top');
  // if (topInfoBlock) {
  //   const conditionalBlocks = topInfoBlock.querySelectorAll(
  //     '.ms-item__info-conditional',
  //   );
  //   conditionalBlocks.forEach((block) => {
  //     block.remove();
  //   });

  //   const trending = topInfoBlock.querySelector('.ms-item__icon--trending');
  //   if (trending) {
  //     trending.remove();
  //   }

  //   const series = topInfoBlock.querySelector('.ms-item__series');
  //   if (series) {
  //     series.classList.remove('ms-item__sponsored');
  //     series.innerHTML = recommendation.series_title;
  //   }

  //   const date = topInfoBlock.querySelector('.ms-item__date');
  //   if (date) {
  //     date.innerHTML = relativeDate;
  //     date.setAttribute('datetime', recommendation.dt_published);
  //   }
  // }

  // const liveBlock = item.querySelector('.ms-item__live');
  // if (liveBlock) {
  //   liveBlock.remove();
  // }
  // const previewBlock = item.querySelector('.ms-item__preview');
  // if (previewBlock) {
  //   previewBlock.remove();
  // }
  // const videoPlayIcon = item.querySelector('.ms-item__play');
  // if (videoPlayIcon) {
  //   videoPlayIcon.remove();
  // }
  // const authorBlock = item.querySelector('.ms-item__author');
  // if (authorBlock) {
  //   authorBlock.remove();
  // }

  // item.setAttribute('title', recommendation.title);
  // item.setAttribute('data-entity-id', formatItemId(recommendation.item_id));

  const title = item.querySelector('.item-recommendation__title');
  // const thumbTitle = item.querySelector('.ms-item__thumb-title');
  if (title) {
    title.innerHTML = recommendation.title;
  }
  // if (thumbTitle) {
  //   thumbTitle.innerHTML = recommendation.title;
  // }

  if (item.tagName.toLowerCase() === 'a') {
    // console.log(item, item.tagName, recommendation.uri);
    item.setAttribute('href', recommendation.uri);
  }

  item.classList.add(finalSettings.froomleItemCls);
  disableSkeletonForItem(item);
};

/**
 * Updates scoped item to show recommendation provided by Froomle
 */

/**
 * Updates scoped item to show recommendation provided by Froomle
 * @param {any} finalSettings
 * @param {HTMLElement} item
 * @param {any} recommendation
 * @param {HTMLElement} widget
 * @returns
 */
export const updateItemToFroomleRecommendationScoped = (
  finalSettings,
  item,
  recommendation,
  widget,
) => {
  const widgetParams = widgetToWidgetParamsMap.get(widget);
  if (!widgetParams) return;

  const { widgetName, widgetScope } = widgetParams;

  if (widgetScope === 'article-body') {
    if (widgetName === 'read-also') {
      updateItemToFroomleRecommendationArticleBodyReadAlso(
        finalSettings,
        item,
        recommendation,
      );
      return true;
    }
  }

  return false;
};

/**
 * Updates item in article body "Read also" block to show recommendation provided by Froomle
 */
const updateItemToFroomleRecommendationArticleBodyReadAlso = (
  finalSettings,
  item,
  recommendation,
) => {
  item.href = recommendation.uri;
  item.title = recommendation.title;

  item.dataset.entityId = formatItemId(recommendation.item_id);

  const img = item.querySelector('img');
  if (img) {
    // we create new image to make sure that old one won't show up until new is loading
    const newImg = img.cloneNode();
    newImg.src = recommendation.images[0].replace(
      `/${finalSettings.froomleImageSize}/`,
      '/s200/',
    );
    newImg.alt = recommendation.title;
    img.replaceWith(newImg);
  }

  const series = item.querySelector('.relatedContent__series');
  if (series) {
    series.innerHTML = recommendation.series_title;
  }

  const title = item.querySelector('.relatedContent__text');
  if (title) {
    title.innerHTML = recommendation.title;
  }

  item.classList.remove(finalSettings.msntSkeletonItemCls);
  item.classList.add(
    finalSettings.msntItemAbTestTargetCls,
    // required to detect clicks on element
    finalSettings.froomleItemCls,
  );
};

const updateItemImages = (item, recommendation) => {
  const picture = item.querySelector('picture');
  if (!picture) return;
  const sources = picture.querySelectorAll('source');
  if (!sources.length) return;
  const img = picture.querySelector('img');
  if (!img) return;

  const baseImg = recommendation.images[0];

  // console.log('FIRST', item, recommendation, baseImg);
  // console.log('FIRSTH', picture, sources, img);

  // we create new image to make sure that old one won't show up until new is loading
  const newImg = img.cloneNode();
  newImg.src = baseImg;
  newImg.setAttribute('alt', recommendation.title);

  // console.log('SECOND', item, recommendation, newImg);

  if (img.classList.contains('videoplayer')) {
    img.classList.remove('videoplayer');
  }

  img.replaceWith(newImg);

  const [imgPathBeforeSize, imgPathAfterSizeNoExtension] = baseImg
    .replace(/\.\w+$/, '')
    .split(/\/s\d+\//);

  // console.log(
  //   'imgPathBeforeSize, imgPathAfterSizeNoExtension',
  //   imgPathBeforeSize,
  //   imgPathAfterSizeNoExtension,
  // );

  sources.forEach((source) => {
    const targetExtension = froomleSettings.mediaTypeToExtension[source.type];
    // console.log('FOURTH', targetExtension);
    if (!targetExtension) {
      logDebug(
        `No media type mapping provided for "${source.type}"`,
        undefined,
        'warn',
      );
      return;
    }

    const sizesWithoutExtension = [];
    let currentSize = froomleSettings.minImageSize;
    // console.log(
    //   'final check',
    //   currentSize,
    //   froomleSettings.maxImageSize,
    //   currentSize <= froomleSettings.maxImageSize,
    // );
    while (currentSize >= froomleSettings.maxImageSize) {
      sizesWithoutExtension.push(
        `${imgPathBeforeSize}/s${currentSize}/${imgPathAfterSizeNoExtension}.${targetExtension} ${froomleSettings.sizesLookUpTable[currentSize]}w`,
      );

      currentSize -= froomleSettings.imageSizesStep;
    }

    // console.log(sizesWithoutExtension);

    source.srcset = sizesWithoutExtension.join(',');
  });
};
